import type { RemoteTrack } from 'livekit-client';

import type { CallKind } from '@/shared/services/api/types';

/**
 * Le son d'un appel dans un navigateur : il n'y a ni session audio ni
 * écouteur à choisir, le son sort par la sortie du système. Il faut en
 * revanche brancher chaque piste reçue sur un élément `<audio>`, que WebRTC
 * ne crée pas de lui-même.
 *
 * Même contrat que le module du téléphone (`bul-mobile`), pour que le moteur
 * d'appel (`call-session.ts`) soit le même fichier des deux côtés.
 */
export function startCallAudio(_kind: CallKind): Promise<void> {
  return Promise.resolve();
}

export function stopCallAudio(): Promise<void> {
  return Promise.resolve();
}

export function routeToSpeaker(_speaker: boolean): Promise<void> {
  return Promise.resolve();
}

export function attachRemoteAudio(track: RemoteTrack): () => void {
  const element = track.attach();
  element.hidden = true;
  document.body.appendChild(element);
  return () => {
    track.detach(element);
    element.remove();
  };
}

/** Le navigateur ne choisit pas entre haut-parleur et écouteur. */
export const SPEAKER_TOGGLE_SUPPORTED = false;
